import moment from "moment";
import axios from "axios";

export const isOneDaySelected = (date) => {
  return date.begin === date.end;
  // return moment(date.end).diff(moment(date.begin), 'days') === 1;
}

export const fetchLastDay = async (symbol) => {
  const language = drupalSettings.path.currentLanguage || '';

  try {
    let resp = await axios.get(
          `/` + language + `/api/market/${symbol}/day/last`
    );
    return resp.data.date;
  } catch (e) {
    console.log(e.response);
    return e.response.data.message;
  }
};
